import { render, staticRenderFns } from "./x-real-time.vue?vue&type=template&id=0ad0b070&scoped=true"
import script from "./x-real-time.vue?vue&type=script&lang=js"
export * from "./x-real-time.vue?vue&type=script&lang=js"
import style0 from "./x-real-time.vue?vue&type=style&index=0&id=0ad0b070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad0b070",
  null
  
)

export default component.exports